export default __webpack_public_path__ + "static/media/Paritosh-Prajapati.07752720.jpeg";